export default __webpack_public_path__ + "static/media/wallpaperthree.a10f17f0.gif";